import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'antim-autoware-button',
  standalone: false,
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {

  @Input() btnType: 'primary' | 'primaryWithoutBorder' | 'primaryOutline' | 'secondary' | 'secondaryWithoutBorder' | 'secondaryOutline' | 'warning' | 'warningOutline' | 'success' | 'error' = 'primary';
  @Input() disabled = false;
  @Input() isSubmitted = false;
  @Input() type = 'button';
  @Input() id = '';
  @Input() name = '';
  @Input() buttonStyle: object = {};
  @Input() matTooltipValue: any = '';

  @Input() leftIcon = '';

  @Input() labelStyle: object = {};
  @Input() label: string = '';

  @Input() rightIcon = '';

  @Output() clickEvent: EventEmitter<any> = new EventEmitter();

  fillColor: any;
  constructor(private router: Router) { }

  onClickButton(event: any): void {
    this.clickEvent.emit(event);
  }

  itemToolTipText() {
    return this.matTooltipValue;
  }
}
